/* This example requires Tailwind CSS v2.0+ */
import { LockOpenIcon, ShieldCheckIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import { URLS } from 'lib/constants';

const { nistGov } = URLS;

const features = [
  {
    name: 'What does OTP mean?',
    description: (
      <>
        OTP stands for <strong>O</strong>ne-<strong>T</strong>ime{' '}
        <strong>P</strong>asscode. It is a random, single-use, 6 digit code used
        to verify a user's identity. Best-practices for generating and verifying
        passcodes are defined by{' '}
        <Link legacyBehavior href={nistGov}>
          <a target="_blank"> NIST 800-63B</a>
        </Link>
        .
      </>
    ),
    icon: ShieldCheckIcon
  },
  {
    name: 'What is OTP authentication?',
    description:
      'To be used for authentication, one-time passcodes can be sent to a user by SMS or email.  If the user can verify the code they were sent, it means they control the email address or phone number where it was delivered.',
    icon: LockOpenIcon
  }
];

export function Definitions() {
  return (
    <div className="pt-8 pb-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="md:grid md:grid-cols-2 md:gap-x-8 lg:gap-x-16">
          {features.map(feature => (
            <div key={feature.name} className="relative mt-8">
              <div>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <feature.icon className="h-6 w-6" aria-hidden="true" />
                </div>
                <h2 className="ml-16 text-xl font-medium leading-6 text-gray-900">
                  {feature.name}
                </h2>
              </div>
              <div className="mt-2 ml-16 text-lg text-gray-500 md:text-base lg:text-lg">
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
